export const STATUS_TYPE = {
  0: { text: '已提交', color: 'info', order: 1 },
  1: { text: '已处理', color: 'success', order: 3 },
  2: { text: '处理中', color: 'warning', order: 2 },
  3: { text: '已退回', color: 'danger', order: 4 }
};

export const TICKET_TYPE = {
  0: 'Google验证码丢失',
  1: 'KYC认证审批',
  2: '提现审批',
  3: '其他'
};
